export const authenticatorLinks = {
  google:
    'https://support.google.com/accounts/answer/1066447?hl=en&co=GENIE.Platform%3DiOS&oco=0',
  microsoft:
    'https://www.microsoft.com/en-us/security/mobile-authenticator-app',
};
